function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgCrown = function SvgCrown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC733"
    },
    d: "M471.688,448.561H40.311c-8.836,0-16-7.164-16-15.999v-81.681c0-8.836,7.164-15.999,16-15.999 h431.376c8.836,0,16,7.164,16,15.999v81.681C487.687,441.398,480.525,448.561,471.688,448.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF00"
    },
    d: "M471.689,334.882H256v113.68h215.688c8.836,0,16-7.164,16-15.999v-81.681 C487.688,342.045,480.525,334.882,471.689,334.882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE365"
    },
    d: "M483.949,100.035L373.852,225.934L269.275,70.501c-6.334-9.413-20.213-9.416-26.55,0L138.148,225.934 L28.051,100.035c-10.24-11.708-29.524-3.302-27.962,12.143l24.222,239.511v15.193c20.998,0,446.531,0,463.375,0v-15.193 l24.223-239.511C513.474,96.729,494.186,88.329,483.949,100.035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC733"
    },
    d: "M483.949,100.035L373.852,225.934L269.275,70.501c-3.167-4.707-8.221-7.061-13.274-7.061v303.44 c111.635,0,223.226,0,231.688,0v-15.193l24.223-239.511C513.474,96.729,494.186,88.329,483.949,100.035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7976"
    },
    d: "M256,308.407c-28.634,0-51.929-23.295-51.929-51.929c0-28.634,23.295-51.929,51.929-51.929 c28.635,0,51.93,23.295,51.93,51.929C307.931,285.112,284.634,308.407,256,308.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5752"
    },
    d: "M307.929,256.478c0-28.634-23.295-51.929-51.929-51.929v103.858 C284.634,308.407,307.929,285.111,307.929,256.478z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/crown.b54443aa.svg";
export { ForwardRef as ReactComponent };